import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddCardComponent } from '../add-card/add-card.component';
import { UserService } from '../../services/user.service';
import { SetPaymentMethodComponent } from './set-payment-method/set-payment-method.component';
import { DeleteCustomerCardComponent } from 'src/app/customer/edit-customer/delete-customer-card/delete-customer-card.component';
import { CollaboratorsService } from 'src/app/services/collaborators.service';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrl: './payment-methods.component.scss',
  standalone: false
})
export class PaymentMethodsComponent {
  loading: boolean = false;
  processing: any;
  client_secrets: any;
  paymentMethods: any[] = [];
  errorMassage!: string;
  subscription_plans:any
  constructor(public userService: UserService, public dialog: MatDialog, public collaboratorsService: CollaboratorsService) {
  }
  ngOnInit() {
    this.userService.checkSubscriptionPlanStatus().subscribe((responces:any) =>{
      console.log('responces',responces);
      this.subscription_plans = responces.subscription;
      
      
    })
    this.checkClientSecret();
    this.loadClientSecret()
    this.displayUserPayment();

  }
  loadClientSecret() {
    this.userService.loadClientSecret().subscribe((response: any) => {
      const clientSecret = atob(response.client_secret);
      this.client_secrets = clientSecret;
    });
  }
  paymentMethod() {
    const dialogRef = this.dialog.open(AddCardComponent, {
      width: '600px',
      data: { client_secret: this.client_secrets }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.paymentMethodAdded) {
        this.displayUserPayment();
      }
    });

    this.loadClientSecret()
  }

  displayUserPayment() {
    this.loading = true;
    this.userService.getPaymentMethod().subscribe((result) => {
      this.paymentMethods = result.methods.payment_methods;
      console.log('this.paymentMethods',this.paymentMethods);
      
      this.loading = false;
    });
  }
  cardDefault(method: any) {
    const dialogRef = this.dialog.open(SetPaymentMethodComponent, {
      width: '600px',
      data: { methods: method }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.primaryCard) {
        this.displayUserPayment();
      }
    });
  }
  deletecard(cards: any) {
    const dialogRef = this.dialog.open(DeleteCustomerCardComponent, {
      width: '500px',
      data: {
        value: cards,
        subscription_plans:this.subscription_plans
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('result',result);   
      if (result == true) { 
        this.displayUserPayment();
      }
    });
  }
  checkClientSecret() {
    try {
      this.userService.getClientSecret().subscribe((response: any) => {
        this.errorMassage = response.message;
        if(this.errorMassage){
          this.loading = false;
        }
      });
    } catch (error) {
      this.loading = false;
      console.log('Error fetching client secret:', error);
    }
  }

  showError() {
    console.log('Error Massage', this.errorMassage);

    const dialogRef = this.dialog.open(SetPaymentMethodComponent, {
      width: '600px',
      data: { errorMassage: this.errorMassage }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.errorHandled) {
        this.displayUserPayment();
      }
    });
  }
  getCardIcon(brand: string) {
  const map: any = {
    visa: 'https://cdn-icons-png.flaticon.com/512/196/196578.png',
    mastercard: 'https://cdn-icons-png.flaticon.com/512/196/196561.png',
    amex: 'https://cdn-icons-png.flaticon.com/512/349/349221.png',
    discover: 'https://cdn-icons-png.flaticon.com/512/349/349230.png',
    jcb: 'https://cdn-icons-png.flaticon.com/512/349/349228.png',
    diners: 'https://cdn-icons-png.flaticon.com/512/349/349222.png'
  };

  return map[brand] || 'https://cdn-icons-png.flaticon.com/512/565/565547.png';
}
}
